// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeOtpRedeemBody = {
  token: string;
};

export type typeOtpRedeemOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    accessToken: string;
    refreshToken: string;
    expiresInSeconds: number;
    user: { userId: string; email: string; isSuperAdmin: boolean };
  };
};

export type typeOtpRedeemOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpRedeemOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeOtpRedeemOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaOtpRedeemBody = {
  type: "object",
  properties: { token: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["token"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createOtpRedeem(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaOtpRedeemBody);
  }

  return async function postOtpRedeem(
    payload: typeOtpRedeemBody,
  ): Promise<typeOtpRedeemOutput200 | typeOtpRedeemOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postOtpRedeem" failed before calling the network. #a7e73bc6bd41`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a7e73bc6bd41" },
        },
        data: null,
      } as typeOtpRedeemOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/otp/redeem`,
      httpMethod: "POST",
      options,
    })) as typeOtpRedeemOutput200 | typeOtpRedeemOutput400;
  };
}
